import StarIcon from "shared/assets/icons/star.svg";
import styled from "styled-components";
import { css } from "twin.macro";

const LuckTitle = styled.section`
  margin-bottom: 14px;
  display: flex;
  align-items: center;
`;

const H3 = styled.h3`
  font-family: HiraMinProN-W6;
  font-size: 18px;
  color: #3c424a;
  letter-spacing: 0.53px;
  margin-right: 8px;
`;

const Content = styled.p`
  font-family: HiraMinProN-W3;
  font-size: 14px;
  color: #3c424a;
  letter-spacing: 0.41px;
  line-height: 24px;
`;

interface Props {
  title: string;
  luckValue: number;
  content: string;
}

export const LuckContent = ({ title, luckValue, content }: Props) => {
  return (
    <>
      <LuckTitle>
        <H3>{title}</H3>
        <StarIcon
          tw="svg text-theme mr-2"
          css={css({ transform: "scale(1.6)" })}
        />
        {[...Array(luckValue)].slice(1, 5).map((index) => (
          <StarIcon
            key={index}
            tw="svg text-theme mr-2"
            css={css({ transform: "scale(1.6)" })}
          />
        ))}
      </LuckTitle>
      <Content>{content}</Content>
    </>
  );
};
